import { render, staticRenderFns } from "./ComboOfferDetail.vue?vue&type=template&id=66dbf5b6"
import script from "./ComboOfferDetail.vue?vue&type=script&lang=js"
export * from "./ComboOfferDetail.vue?vue&type=script&lang=js"
import style0 from "./ComboOfferDetail.vue?vue&type=style&index=0&id=66dbf5b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports